module.exports = __webpack_public_path__ + "static/img/cont58_08.5e5db0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_08.jpg
// module id = jxky
// module chunks = 0